// extracted by mini-css-extract-plugin
export default {"container":"SupportScreen_container__bXqxc","center_align":"SupportScreen_center_align__A07e8"};